import React from 'react';
import ContactForm from '../components/ContactForm';
import GoogleMap from '../components/GoogleMap';
import ScrollToTop from '../components/ScrollToTop';
import { FaUsers, FaMedal, FaGlassCheers, FaRegLightbulb } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

const Teambuilding = () => {
  const { t } = useTranslation();

  return (
    <div className="service-page-container">
      <ScrollToTop />
      <header className="service-page-header">
        <h1>{t('teambuilding.headerTitle')}</h1>
        <p>{t('teambuilding.headerSubtitle')}</p>
      </header>

      <section className="service-details-section">
        <div className="service-details-content">
          <h2>{t('teambuilding.headline')}</h2>
          <p className="intro-text">
            {t('teambuilding.introText')}
          </p>

          <ul className="feature-list">
            <li>
              <div className="feature-icon"><FaUsers /></div>
              <div className="feature-text">
                <strong>{t('teambuilding.inclusiveTitle')}</strong>
                <span>{t('teambuilding.inclusiveDescription')}</span>
              </div>
            </li>
            <li>
              <div className="feature-icon"><FaMedal /></div>
              <div className="feature-text">
                <strong>{t('teambuilding.structuredTitle')}</strong>
                <span>{t('teambuilding.structuredDescription')}</span>
              </div>
            </li>
            <li>
              <div className="feature-icon"><FaGlassCheers /></div>
              <div className="feature-text">
                <strong>{t('teambuilding.socialTitle')}</strong>
                <span>{t('teambuilding.socialDescription')}</span>
              </div>
            </li>
            <li>
              <div className="feature-icon"><FaRegLightbulb /></div>
              <div className="feature-text">
                <strong>{t('teambuilding.customizableTitle')}</strong>
                <span>{t('teambuilding.customizableDescription')}</span>
              </div>
            </li>
          </ul>

          <p className="conclusion-text">
            {t('teambuilding.conclusionText')}
          </p>
        </div>
      </section>
      <ContactForm />
      <GoogleMap />
    </div>
  );
};

export default Teambuilding;
